import React, { useContext } from "react";
import { AlertContext } from "./alert.context";

/**
 * Renders a stack of Bootstrap alerts in the top-right corner.
 * Put <AlertContainer /> near top-level (e.g., inside App or layout).
 */
export default function AlertContainer({ position = "top-right", maxVisible = 5 }) {
    const ctx = useContext(AlertContext);
    const alerts = ctx?.alerts ?? [];

    // simple position mapping
    const containerStyle = {
        position: "fixed",
        zIndex: 1080,
        pointerEvents: "none", // allow clicks to fall through except on alerts
    };

    switch (position) {
        case "top-left":
            Object.assign(containerStyle, { top: "1rem", left: "1rem" });
            break;
        case "bottom-left":
            Object.assign(containerStyle, { bottom: "1rem", left: "1rem" });
            break;
        case "bottom-right":
            Object.assign(containerStyle, { bottom: "1rem", right: "1rem" });
            break;
        default: // top-right
            Object.assign(containerStyle, { top: "1rem", right: "1rem" });
    }

    return (
        // aria-live for screen readers
        <div style={containerStyle} aria-live="polite" aria-atomic="true">
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", minWidth: 300 }}>
                {alerts.slice(0, maxVisible).map((a) => (
                    <div
                        key={a.id}
                        className={`alert alert-${a.type} alert-dismissible fade show`}
                        role="alert"
                        style={{ pointerEvents: "auto", boxShadow: "0 4px 10px rgba(0,0,0,0.08)" }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                            <div style={{ flex: 1 }}>{a.message}</div>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => ctx.hide(a.id)}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
